export const HIGH_QUALITY_PRINT_DPI = 200; //for good print quality better to have 300
export const PDF_DPI = 72;

const PIXEL = 1;
export const POINTS_IN_PIXEL = PIXEL * 0.75;

export const INCH_RATIO = PDF_DPI / POINTS_IN_PIXEL;

export const PRINT_RATIO = HIGH_QUALITY_PRINT_DPI / INCH_RATIO;
